export default "__VITE_ASSET__Ci0Uk3rl__"